import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Wallet, ArrowUpRight, ArrowDownRight } from "lucide-react";

const REASON_LABEL = {
  referral_signup: "Filleul inscrit",
  referral_double_bonus: "Bonus 1re mission",
  unlock_used: "Déblocage utilisé",
};

export default function CreditHistory() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/me/credits/history").then(r => setData(r.data)).catch(()=>{}); }, []);
  if (!data) return null;
  return (
    <section className="glass-strong rounded-2xl p-6">
      <h2 className="font-display text-lg font-bold flex items-center gap-2"><Wallet size={16} className="text-[#F59E0B]"/> Portefeuille crédits</h2>
      <div className="mt-3 flex items-center gap-4">
        <div className="glass rounded-xl p-3 min-w-[140px]">
          <div className="text-xs text-slate-400">Solde actuel</div>
          <div className="font-display text-2xl font-bold text-[#F59E0B]">{data.balance}</div>
          <div className="text-[10px] text-slate-500">= {data.balance * 2}€ économisés</div>
        </div>
        <div className="text-xs text-slate-400 flex-1">
          <p>Chaque crédit vaut <b>1 déblocage de contact</b> (valeur 2€).</p>
          <p className="mt-1">Invitez des amis via votre lien de parrainage pour en gagner plus.</p>
        </div>
      </div>
      <h3 className="text-xs uppercase tracking-wider text-slate-500 mt-5 mb-2">Historique</h3>
      <div className="glass rounded-lg divide-y divide-slate-800/60 max-h-56 overflow-y-auto">
        {data.entries.length === 0 && <p className="p-4 text-xs text-slate-500 text-center">Aucun mouvement pour le moment.</p>}
        {data.entries.map(e => (
          <div key={e.entry_id} className="flex items-center gap-3 px-3 py-2 text-xs">
            {e.delta > 0 ? <ArrowUpRight size={14} className="text-emerald-400"/> : <ArrowDownRight size={14} className="text-red-400"/>}
            <div className="flex-1">
              <div className="font-semibold text-slate-200">{REASON_LABEL[e.reason] || e.reason}</div>
              <div className="text-[10px] text-slate-500">{new Date(e.at).toLocaleString("fr-FR")}</div>
            </div>
            <span className={`font-bold ${e.delta>0 ? "text-emerald-400" : "text-red-400"}`}>{e.delta > 0 ? `+${e.delta}` : e.delta}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
